<template>
    <div>
        <swb-mercht-tpl-role-resc-action v-if="activeName == 'rescAction'" :bizUnitLevel="bizUnitLevel" :roleId="roleId" :readOnly="readOnly"></swb-mercht-tpl-role-resc-action>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbMerchtTplRoleRescAction from './MerchtTplRoleRescAction';
    Vue.regist(SwbMerchtTplRoleRescAction);

    import SwbMerchtTplRoleGoodsCat from './MerchtTplRoleGoodsCat';
    Vue.regist(SwbMerchtTplRoleGoodsCat);

    import SwbMerchtTplRoleServcCat from './MerchtTplRoleServcCat';
    Vue.regist(SwbMerchtTplRoleServcCat);

    import SwbMerchtTplRoleShopTag from './MerchtTplRoleShopTag';
    Vue.regist(SwbMerchtTplRoleShopTag);

    import SwbMerchtTplRoleDevcGroup from './MerchtTplRoleDevcGroup';
    Vue.regist(SwbMerchtTplRoleDevcGroup);

    import SwbMerchtTplRoleMgmtArea from './MerchtTplRoleMgmtArea';
    Vue.regist(SwbMerchtTplRoleMgmtArea);

    export default {
        name: 'swb-mercht-tpl-role-business-set',
        desc: '商户模版岗位-业务设置',
        props: {
            bizUnitLevel: {
                type: Number,
                default: null
            },
            roleId: {
                type: Number,
                default: null
            },
            bizPermFlag: {
                type: Boolean,
                default: false
            },
            bizPermOrgFlag: {
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                activeName: 'rescAction'
            }
        },
        created: function () {
            //
        },
        methods: {
            handleClick: function (tab, event) {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleBusinessSet.vue